import {
  provisionClientDriveFn,
  linkClientDriveFn,
  unlinkClientDriveFn,
} from '@/lib/firebase/functions'
import { typedDoc, getDocument } from '@/lib/firebase/firestore'
import type { UserDocument } from '@/types/firebase.types'

export interface ClientDriveResult {
  folderId: string
  folderUrl: string
  folderName: string
}

export const adminClientDriveService = {
  async provision(uid: string): Promise<ClientDriveResult> {
    const { data } = await provisionClientDriveFn({ uid })
    return data
  },

  async link(uid: string, folderUrlOrId: string): Promise<ClientDriveResult> {
    const { data } = await linkClientDriveFn({ uid, folderUrlOrId })
    return data
  },

  async unlink(uid: string): Promise<void> {
    await unlinkClientDriveFn({ uid })
  },

  async getClientUser(uid: string): Promise<UserDocument | null> {
    return getDocument(typedDoc<UserDocument>('users', uid))
  },

  async getClientUsers(uids: string[]): Promise<Map<string, UserDocument>> {
    const results = await Promise.all(
      uids.map(async (uid) => [uid, await getDocument(typedDoc<UserDocument>('users', uid))] as const)
    )
    const out = new Map<string, UserDocument>()
    for (const [uid, doc] of results) if (doc) out.set(uid, doc)
    return out
  },
}
